// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.ztree.zTreeDragUL{margin:0;padding:0;position:absolute;overflow:hidden;background-color:#dedede;border:1px dotted #4fcbf0;border-radius:4px;opacity:.7}.zTreeMask{position:absolute;z-index:10000;opacity:0;background-color:#cfcfcf}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
